import { filterAwarenessStates } from './awareness';

export function normalizeCollaboratorPicture(value) {
  if (typeof value !== 'string' || value.length > 2048) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && !url.port
      && (url.hostname === 'googleusercontent.com' || url.hostname.endsWith('.googleusercontent.com'))
      ? url.href : null;
  } catch { return null; }
}

export function deriveCollaborators(states, currentUserId) {
  const users = new Map();
  for (const state of filterAwarenessStates(states).sort((a, b) => a.clientId - b.clientId)) {
    if (state.userId === currentUserId) continue;
    const previous = users.get(state.userId);
    // Multiple tabs/devices represent one person. Prefer an active editor,
    // then a selected idea, while keeping a deterministic order.
    const rank = entry => (entry?.editingNodeId ? 2 : entry?.selectedNodeId ? 1 : 0);
    if (!previous || rank(state) > rank(previous)) users.set(state.userId, {
      userId: state.userId, displayName: state.displayName || 'Collaborator',
      selectedNodeId: state.selectedNodeId, editingNodeId: state.editingNodeId,
    });
  }
  return [...users.values()].sort((a, b) => a.displayName.localeCompare(b.displayName) || a.userId.localeCompare(b.userId));
}
